import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { PageHeader, PageHeaderContent, PageLabel, TabNav, TabNavItem } from 'components';
import ConnectedSiteSelector from 'components/SiteSelector/ConnectedSiteSelector';
import { SiteSelectorAppearance } from 'components/SiteSelector/types';
// relative path doesn't import
import { routeConstants } from 'routes';
import { PermissionGate } from 'screens/Security';
import { selectSiteSettings } from 'store/Site';
import { AchType, EmployeeRole } from 'types';

interface IReportsProps {
  children: ReactNode;
}

const ReportsScreenLayout = ({ children }: IReportsProps) => {
  const currentSiteSettings = useSelector(selectSiteSettings());

  return (
    <>
      <PageHeader>
        <PageLabel>Reports</PageLabel>
        <PageHeaderContent>
          <ConnectedSiteSelector appearance={SiteSelectorAppearance.PAGE_HEADER} />
        </PageHeaderContent>
        <TabNav>
          <TabNavItem data-cy="paid-payments-nav-btn" label="Paid Payments" to={routeConstants.private.reportsPaidPayments} />
          <TabNavItem data-cy="payroll-tips-nav-btn" label="Pay Period" to={routeConstants.private.reportsPayrollTips} />
          <TabNavItem data-cy="bank-reconciliation-nav-btn" label="Bank Reconciliation" to={routeConstants.private.reportsBankReconciliation} />
          <TabNavItem data-cy="ledger-nav-btn" label="Ledger" to={routeConstants.private.reportsLedger} />
          {currentSiteSettings?.achType === AchType.KICKFIN && (
            <PermissionGate requiredRoles={[EmployeeRole.ADMIN, EmployeeRole.SITE_ADMIN]}>
              <TabNavItem data-cy="ach-history-nav-btn" label="ACH History" to={routeConstants.private.reportsAchHistory} />
            </PermissionGate>
          )}
        </TabNav>
      </PageHeader>

      {children}
    </>
  );
};

export default ReportsScreenLayout;
